import { Link } from "react-router-dom";

export default function CtaSection({
  title = "Interesse an einem Sponsoring?",
  text,
  ctaLabel = "Kontakt aufnehmen",
  ctaTo = "/kontakt",
}) {
  return (
    <section className="bg-primary text-white">
      <div className="mx-auto max-w-6xl px-4 py-16 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        <div>
          <h2 className="text-3xl md:text-4xl font-extrabold uppercase">{title}</h2>
          {text && <p className="mt-3 text-white/80 text-lg max-w-xl leading-relaxed">{text}</p>}
        </div>
        <Link
          to={ctaTo}
          className="self-start flex-shrink-0 inline-flex items-center gap-2 bg-accent px-8 py-3 font-bold text-white uppercase tracking-wide text-sm hover:bg-white hover:text-primary transition-colors"
        >
          {ctaLabel}
          <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </Link>
      </div>
    </section>
  );
}
